import { telegram } from './telegram';
import { useSettings } from '../store/settings';
export function feedback(kind: 'success' | 'error' | 'selection'): void {
  if (useSettings.getState().hapticsEnabled) telegram.haptic(kind);
}
